@if (warning()) {
  <span class="error" [translate]="warningKey()"></span>
}
